var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.885 16.9998C5.75228 17.0025 5.62066 16.9753 5.5 16.9201C5.19067 16.7753 4.99507 16.4634 5 16.1229V13.9654H3.25C2.55964 13.9654 2 13.4077 2 12.7197V5.24567C2 4.55771 2.55964 4 3.25 4H16.75C17.4404 4 18 4.55771 18 5.24567V12.7197C18 13.4077 17.4404 13.9654 16.75 13.9654H9.69L6.455 16.7856C6.29666 16.9223 6.09454 16.9983 5.885 16.9998ZM3.25 4.99654C3.11193 4.99654 3 5.10808 3 5.24567V12.7197C3 12.8573 3.11193 12.9688 3.25 12.9688H5.5C5.6329 12.9681 5.76064 13.0201 5.855 13.1133C5.94859 13.2074 6.00077 13.3347 6 13.4671V15.8438L9.165 13.0884C9.25817 13.009 9.3774 12.9664 9.5 12.9688H16.75C16.8881 12.9688 17 12.8573 17 12.7197V5.24567C17 5.10808 16.8881 4.99654 16.75 4.99654H3.25ZM6 9.97922C6.55228 9.97922 7 9.53305 7 8.98268C7 8.43231 6.55228 7.98615 6 7.98615C5.44772 7.98615 5 8.43231 5 8.98268C5 9.53305 5.44772 9.97922 6 9.97922ZM11 8.98268C11 9.53305 10.5523 9.97922 10 9.97922C9.44772 9.97922 9 9.53305 9 8.98268C9 8.43231 9.44772 7.98615 10 7.98615C10.5523 7.98615 11 8.43231 11 8.98268ZM14 9.97922C14.5523 9.97922 15 9.53305 15 8.98268C15 8.43231 14.5523 7.98615 14 7.98615C13.4477 7.98615 13 8.43231 13 8.98268C13 9.53305 13.4477 9.97922 14 9.97922Z",
    fill: "#2867B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/SMS.b524d731daefd2113531d08fc60b8058.svg";
export { ForwardRef as ReactComponent };